import classNames from 'classnames'
import React from 'react'

export interface LegendIndicatorProps {
  fillColor?: string
  borderColor?: string
  image?: string
}

export function LegendIndicator({ fillColor, borderColor, image }: LegendIndicatorProps) {
  const classes = classNames('c-legend-indicator', {
    'c-legend-indicator--has-border': !!borderColor,
    'c-legend-indicator--has-image': !!image,
  })

  if (!!image) {
    return (
      <div className={classes} aria-hidden>
        <img src={image} className='c-legend-indicator__img' alt='' />
      </div>
    )
  }

  if (fillColor || borderColor) {
    return <div className={classes} style={{ borderColor: borderColor, backgroundColor: fillColor }} aria-hidden></div>
  }

  return null
}
